const AnalysisTaskConstants = {
  RESUBMIT_TASK: "analysisTask/RESUBMIT_TASK",
  RESUBMITTING_TASK: "analysisTask/RESUBMITTING_TASK",
  RESUBMITTED_TASK: "analysisTask/RESUBMITTED_TASK",
  CANCEL_TASK: "analysisTask/CANCEL_TASK",
  CANCELLING_TASK: "analysisTask/CANCELLING_TASK",
  CANCELLED_TASK: "analysisTask/CANCELLED_TASK",
  RESET_TASK_ACTIONS: "analysisTask/RESET_TASK_ACTIONS"
};
export {
  AnalysisTaskConstants as default
};
//# sourceMappingURL=AnalysisTaskConstants.js.map
